const SHOW = 'show';

export default class {
    constructor(id) {
        this.id = this.formatId(id);
        this.storageName = 'storefront_tourtip_state';
        const flag = this.getFlag();
        this.setFlag(flag || SHOW); // If not found, then show
    }
    isOpen() {
        return this.getFlag() === SHOW;
    }
    formatId(id) {
        return id.replace(/[-|\s]/g, ''); // Name has to be valid JSON key
    }
    saveCollapse() {
        this.setFlag('hide');
    }
    getFlag() {
        const storage = this.getStorage();
        if (storage !== undefined) {
            return storage[this.id];
        }
    }
    setFlag(flag) {
        if (window.localStorage) {
            const storage = this.getStorage() || {};
            storage[this.id] = flag;
            window.localStorage.setItem(this.storageName, JSON.stringify(storage));
        }
    }
    getStorage() {
        // Expecting the stored item, once parsed to object, to be a map:
        // { additionalItemsSeeAll: 'hide', anotherTooltipName: 'hide', ... }
        if (window.localStorage) {
            const tourtipState = window.localStorage.getItem(this.storageName);
            if (tourtipState) {
                try {
                    return JSON.parse(tourtipState);
                } catch (err) {
                    // Do nothing
                }
            }
        }
    }
}
